import type { AddressApi } from "./address";

export enum ApplicationStatus {
	UnderReview = "UnderReview",
	Approved = "Approved",
	Rejected = "Rejected",
	Inactive = "Inactive"
}

export type PartnerSearch = {
	status?: ApplicationStatus[]
};

export type LogoApi = {
	light?: string;
	dark?: string;
	logoMark?: string;
};

export type PartnerInfoApi = {
	id: string;
	name: string;
	url?: string;
	logo: LogoApi;
	cmsId?: number;
	paywallId?: number;
	payoutCurrencyId?: number;
	ein?: string;
	status: ApplicationStatus
	emailVerified?: boolean;
};

export type PartnerFullApi = {
	partner: {
		name: string;
		url: string;
		cmsId?: number;
		paywallId?: number;
		payoutCurrencyId?: number;
		ein?: string;
		logo?: LogoApi;
		status?: ApplicationStatus;
	},
	contact: {
		name: string;
		title: string;
		email: string;
		phone?: string | null;
		company: string;
		emailVerified: boolean;
		address?: AddressApi;
	}
};

export type PartnerApplicationApi = {
	partner: {
		name: string;
		url: string;
	};
	contact: {
		name: string;
		email: string;
		phone?: string | null;
		company: string;
		title: string;
		emailVerified: boolean;
	}
};

export type PartnerCms = {
	id: number;
	name: string;
};

export type PartnerPaywall = PartnerCms;